import conversations from './sidebarItems/conversations';
import contacts from './sidebarItems/contacts';
import reports from './sidebarItems/reports';
import campaigns from './sidebarItems/campaigns';
import settings from './sidebarItems/settings';
import notifications from './sidebarItems/notifications';
import primaryMenu from './sidebarItems/primaryMenu';
import credit_balance from './sidebarItems/credit_balance';
import catalogues from './sidebarItems/catalogues';
import ai from './sidebarItems/ai';
import calendars from './sidebarItems/calendar';

export const getSidebarItems = accountId => ({
  primaryMenu: primaryMenu(accountId),
  secondaryMenu: [
    conversations(accountId),
    contacts(accountId),
    reports(accountId),
    campaigns(accountId),
    settings(accountId),
    notifications(accountId),
    credit_balance(accountId),
    catalogues(accountId),
    ai(accountId),
    calendars(accountId),
  ],
});
